/**
 * URL publica de un remate (o de la ficha de un animal), respetando si el
 * productor tiene el micrositio INCRUSTADO en su propio sitio.
 *
 * Dos caminos, los mismos que ya usaban los share links:
 *
 *  1) Embed externo ON — el productor publica el micrositio dentro de su
 *     dominio (ej. remates.cabanapilaga.com.ar). Hay que mandarlo AHI: la ruta
 *     /remate/... de PUJA existe, pero lo saca del sitio del productor y lo
 *     deja en un dominio que no reconoce. El deep-link del animal viaja como
 *     `?animal=` porque el que rutea adentro del iframe es el script del embed.
 *
 *  2) Embed externo OFF (default) — ruta propia del SPA de PUJA.
 *
 * Es una funcion pura: recibe la config y devuelve el string. No lee
 * `window.location` para poder testearla.
 */

/** Igual que el del micrositio: el backend resuelve por el id, la cola es cosmetica. */
const slugify = (texto) => (texto || '')
  .toLowerCase()
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .trim()
  .replace(/[^a-z0-9]+/g, '-')
  .replace(/^-+|-+$/g, '');

/**
 * @param {object}  opts
 * @param {object}  opts.config       config del micrositio del evento
 * @param {string}  opts.eventoSlug   slug del evento
 * @param {object} [opts.animal]      { id, nombre } si se apunta a una ficha
 * @returns {string} URL relativa (PUJA) o absoluta (dominio del productor)
 */
export function urlMicrositio({ config, eventoSlug, animal } = {}) {
  if (!eventoSlug) return '';

  const animalParam = animal?.id
    ? `${animal.id}${slugify(animal.nombre) ? `-${slugify(animal.nombre)}` : ''}`
    : null;

  const base = (config?.url_embed_publico || '').trim();
  if (config?.embed_externo && base) {
    const raiz = base.replace(/\/$/, '');
    const qs = new URLSearchParams({ evento: eventoSlug });
    if (animalParam) qs.set('animal', animalParam);
    return `${raiz}?${qs.toString()}`;
  }

  return animalParam
    ? `/remate/${eventoSlug}/animal/${animalParam}`
    : `/remate/${eventoSlug}`;
}
